import { Space } from 'antd'
import { Permission, alphabeticalSort } from '@cims-online/shared'
import { CIMSTags } from 'components/CIMSTags'
import { PermissionViewerProps } from './types'
import CIMSCollapse from 'components/CIMSCollapse'

const PermissionViewer: React.FC<PermissionViewerProps> = ({
  additionalPermissionIds,
  roles,
}) => {
  if (!additionalPermissionIds?.length && !roles?.length) return null
  const allPermissionIds = [
    ...new Set([
      ...(additionalPermissionIds ?? []),
      ...(roles
        ?.filter(({ permissions }) => permissions)
        .flatMap(({ permissions }) => permissions) ?? []),
    ]),
  ]
  const allPermissionsMap = Permission.moduleToPageToBasics
  return (
    <CIMSCollapse
      multiple
      panels={[...allPermissionsMap.keys()]
        .filter((moduleItem) =>
          Permission.findByModule(moduleItem)
            .map(({ id }) => id)
            .some((id) => allPermissionIds.includes(id))
        )
        .sort(alphabeticalSort('name'))
        .map((moduleItem) => ({
          key: moduleItem.id,
          header: moduleItem.name,
          children: (
            <Space size="large" direction="vertical">
              {[...allPermissionsMap.get(moduleItem)!.entries()]
                .filter(([_, pagePermissions]) =>
                  pagePermissions
                    .map(({ id }) => id)
                    .some((id) => allPermissionIds.includes(id))
                )
                .map(([pageItem, pagePermissions]) => (
                  <Space key={pageItem.id} direction="vertical" size="small">
                    {`${pageItem.name}: `}
                    <CIMSTags
                      tags={pagePermissions
                        .filter(({ id }) => allPermissionIds.includes(id))
                        .map(({ id, name, description }) => ({
                          key: id,
                          text: name,
                          color:
                            roles && additionalPermissionIds?.includes(id)
                              ? 'blue'
                              : undefined,
                          tooltip: description,
                        }))}
                    />
                  </Space>
                ))}
            </Space>
          ),
        }))}
    />
  )
}

export default PermissionViewer
